export const windowAvailable = () => typeof window !== 'undefined';
export const navigatorAvailable = () => typeof navigator !== 'undefined';
